(function () {
    'use strict';

    angular.module("imApp").factory("subscriptionsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSubscriptions: function (parms) {
                return $ihttp.post({
                    method: 848,
                    parameters: parms || {}
                });
            },
            listSubscriptions: function (parms) {
                return $ihttp.post({
                    method: 109,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
